<template>
  <el-aside>
    <div class="aside-page test-1">
      <el-radio-group class="radio-group" v-model="isCollapse">
        <el-radio-button :label="false" v-show="true === isCollapse">
          <i class="fs24 c_fff el-icon-s-unfold"></i>
        </el-radio-button>
        <el-radio-button :label="true" v-show="false === isCollapse">
          <i class="fs24 c_fff el-icon-s-fold"></i>
        </el-radio-button>
      </el-radio-group>

      <el-menu :default-active="this.$route.path" :collapse="isCollapse" class="el-menu-vertical-demo" router
        :unique-opened="true">
        <div v-for="(item, ind) in option" :key="ind" :index="item.id + ''">
          <el-menu-item class="homeItem" v-if="item.children.length == 0" :index="item.url"
            :route="{ path: item.url}">
            <i :class="item.icon"></i>
            <!-- <i class="iconfont" :class="item.icon"></i> -->
            <span slot="title">{{ item.entityName }}</span>
          </el-menu-item>
          <template v-else>
            <el-submenu :index="item.id + ''">
              <template slot="title">
                <i :class="item.icon"></i>
                <!-- <i class="iconfont" :class="item.icon"></i> -->
                <span slot="title">{{ item.entityName }}</span>
              </template>
              <el-menu-item class="itemLi" v-for="(list, i) in item.children" :key="i" :index="list.url"
                :route="{ path: list.url }">
                {{ list.entityName }}
              </el-menu-item>
            </el-submenu>
          </template>
        </div>
      </el-menu>
    </div>
  </el-aside>
</template>

<script>
export default {
  data() {
    return {
      hasIndex: sessionStorage.getItem("hasIndex"),
      isCollapse: false,
      option: []
    };
  },
  created() {
    this.findSidebarList();
  },
  methods: {
    async findSidebarList() {
      let details = await this.service.User.SidebarList({ type: 2 });
      let btsRes = await this.service.User.getBtnList({ type: 2 });
      if (details.code == 0) {
        this.option = details.data.children;
        sessionStorage.setItem("optionAside", JSON.stringify(this.option));
      } else {
        tipsTemplate(details.msg, "error", "1");
      }
      if (btsRes.code == 0) {
        sessionStorage.setItem("bts_M", btsRes.data.buttons);
      } else {
        tipsTemplate(bts.msg, "error", "1");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.el-aside {
  width: auto !important;
  z-index: 2000;
  overflow: hidden;

  .aside-page {
    height: 100%;
    overflow-y: scroll;

    .radio-group {
      position: fixed;
      left: 200px;
      top: 0.5%;
      z-index: 100;
    }

    /deep/ .el-menu {
      border-right: 0;
      background-color: #012953;

      .el-submenu__title {
        background-color: #012953;
        color: #ffffff;

        @media screen and (min-width: 1000px) and (max-width: 1680px) {
          padding-left: 30px !important;
        }

        span {
          i {
            font-size: 16px;
            vertical-align: text-bottom;
          }
        }

        i {
          color: #ffffff;
        }
      }

      .el-submenu__title:hover,
      .el-menu-item.homeItem:hover {
        background-color: #cde5fd;
        color: #333333;
        font-weight: bold;

        i {
          color: #333333;
        }
      }

      .el-menu-item {
        color: #ffffff;

        >.el-icon-s-home {
          color: #ffffff;
        }
      }

      .el-menu-item.itemLi {
        text-indent: 28px;
        color: #333333;

        @media screen and (min-width: 1000px) and (max-width: 1680px) {
          text-indent: 26px;
        }
      }

      .el-menu-item.itemLi:focus,
      .el-menu-item.itemLi:hover {
        background-color: #cde5fd;
        color: #333333;
        font-weight: bold;
        border-right: 4px solid #050505;
      }

      .el-menu-item:hover {
        i {
          color: #909399;
        }
      }

      .el-menu-item.is-active {
        background-color: #cde5fd;
        color: #333333;
        font-weight: bold;
        border-right: 4px solid #050505;

        i {
          color: #909399;
        }
      }

      .el-menu-item.homeItem.is-active {
        background-color: #cde5fd;
        color: #012953;
        border-right: 4px solid #050505;

        i {
          color: #012953;
        }
      }

      .el-menu-item.homeItem:focus {
        .el-icon-s-home {
          color: #333333;
        }

        >span {
          color: #333333;
          font-weight: bold;
        }
      }

      .el-menu.el-menu--inline {
        width: 100%;
        background-color: #ffffff;
      }
    }

    .el-menu--collapse {
      height: 100%;
    }

    /deep/ .el-tooltip {
      i {
        color: #ffffff;
      }
    }
  }

  /deep/ .el-radio-button__inner {
    background: transparent;
    border: 0 !important;
  }
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 100%;

  @media screen and (min-width: 1000px) and (max-width: 1680px) {
    width: 250px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/comAside.vue